module.exports = __webpack_public_path__ + "fonts/TrustSans-Regular.13e63b5a.woff2";